import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=72446ea3&scoped=true"
import script from "./simple.vue?vue&type=script&lang=js"
export * from "./simple.vue?vue&type=script&lang=js"
import style0 from "./simple.vue?vue&type=style&index=0&id=72446ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72446ea3",
  null
  
)

export default component.exports